import React from 'react'
import { useTranslation } from 'react-i18next'
import { TH } from '../../style'

export const TableHead = () => {
  const { t } = useTranslation()

  return (
    <thead>
      <tr>
        <TH>{t('Name')}</TH>
        <TH>{t('Treatment code')}</TH>
        <TH>{t('Date')}</TH>
        <TH>{t('Employee')}</TH>
        <TH>{t('Employee AGB')}</TH>
        <TH>{t('Number')}</TH>
        <TH>{t('Unit price')}</TH>
        <TH>{t('Unit price Excl.')}</TH>
        <TH>{t('VAT')} %</TH>
        <TH>{t('Discount')} %</TH>
        <TH>{t('Total')}</TH>
        <th />
      </tr>
    </thead>
  )
}
